import { useState, useRef, useEffect } from 'react';
import Address from './Address';
import Phone from './Phone';
import DateInput from './DateInput';
import SSN from './SSN';
import Applicants from './Applicants';
import Income from './Income';
import Citizenship from './Citizenship';
import * as htmlToImage from 'html-to-image'; 
import './ACAForm.css';

export default function ACAForm() {
  const date = new Date();
  const tax_year = date.getMonth() > 9 ? date.getFullYear() + 1 : date.getFullYear();
  const chip_start_dt = new Date();
  chip_start_dt.setMonth(date.getMonth() - 9);
  const chip_start = (chip_start_dt.getMonth() + 1) + '/' + chip_start_dt.getDate() + '/' + chip_start_dt.getFullYear();
  const chip_end_dt = new Date()
  chip_end_dt.setMonth(date.getMonth() + 2);
  const chip_end = (chip_end_dt.getMonth() + 1) + '/' + chip_end_dt.getDate() + '/' + chip_end_dt.getFullYear();
    
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('source') ?? 'yirpartners.com';
  
  const [page, setPage] = useState(1);
  const [noteId, setNoteId] = useState(null);
  const [formData, setFormData] = useState({
    tax_year: tax_year,
    current_year: date.getFullYear(),
    source: source,
    first_submit: "true",
    name: '',
    self_coverage: 'Yes',
    applicant_name: '',
    attest_permission: 'No',
    dob: '',
    gender: '',
    has_ssn: 'Yes',
    no_ssn: '',
    ssn: '',
    email: '',
    cell: '',
    street_address_auto: '',
    street_address: '',
    street_address2: '',
    city: '',
    county: '',
    state: '',
    zip: '',
    mailing_matches: 'Yes',
    mailing_address_auto: '',
    mailing_address: '',
    mailing_address2: '',
    mailing_city: '',
    mailing_county: '',
    mailing_state: '',
    mailing_zip: '',
    is_dependent: 'No',
    who_will_claim_name: '',
    filing_taxes: 'Yes',
    currently_enrolled: 'No',
    will_expire: 'No',
    offer_through_job: 'No',
    citizen_status: 'US Citizen or US National',
    citizen_status_proof_id: '',
    citizen_status_proof: '',
    how_many_dependents: 0,
    how_many_others: 0,
    applicant_1_name: '',
    applicant_2_name: '',
    applicant_3_name: '',
    applicant_4_name: '',
    applicant_5_name: '',
    applicant_6_name: '',
    applicant_1_dob: '',
    applicant_2_dob: '',
    applicant_3_dob: '',
    applicant_4_dob: '',
    applicant_5_dob: '',
    applicant_6_dob: '',
    applicant_1_has_ssn: 'Yes',
    applicant_2_has_ssn: 'Yes',
    applicant_3_has_ssn: 'Yes',
    applicant_4_has_ssn: 'Yes',
    applicant_5_has_ssn: 'Yes',
    applicant_6_has_ssn: 'Yes',
    applicant_1_no_ssn: '',
    applicant_2_no_ssn: '',
    applicant_3_no_ssn: '',
    applicant_4_no_ssn: '',
    applicant_5_no_ssn: '',
    applicant_6_no_ssn: '',
    applicant_1_ssn: '',
    applicant_2_ssn: '',
    applicant_3_ssn: '',
    applicant_4_ssn: '',
    applicant_5_ssn: '',
    applicant_6_ssn: '',
    applicant_1_gender: '',
    applicant_2_gender: '',
    applicant_3_gender: '',
    applicant_4_gender: '',
    applicant_5_gender: '',
    applicant_6_gender: '',
    applicant_1_lives_with: 'Yes',
    applicant_2_lives_with: 'Yes',
    applicant_3_lives_with: 'Yes',
    applicant_4_lives_with: 'Yes',
    applicant_5_lives_with: 'Yes',
    applicant_6_lives_with: 'Yes',
    applicant_1_relationship: 'Spouse',
    applicant_2_relationship: 'Child',
    applicant_3_relationship: 'Child',
    applicant_4_relationship: 'Child',
    applicant_5_relationship: 'Child',
    applicant_6_relationship: 'Child',
    applicant_1_tax_status: 'Filing jointly',
    applicant_2_tax_status: 'Dependent',
    applicant_3_tax_status: 'Dependent',
    applicant_4_tax_status: 'Dependent',
    applicant_5_tax_status: 'Dependent',
    applicant_6_tax_status: 'Dependent',
    applicant_1_address_auto: '',
    applicant_2_address_auto: '',
    applicant_3_address_auto: '',
    applicant_4_address_auto: '',
    applicant_5_address_auto: '',
    applicant_6_address_auto: '',
    applicant_1_address: '',
    applicant_2_address: '',
    applicant_3_address: '',
    applicant_4_address: '',
    applicant_5_address: '',
    applicant_6_address: '',
    applicant_1_address2: '',
    applicant_2_address2: '',
    applicant_3_address2: '',
    applicant_4_address2: '',
    applicant_5_address2: '',
    applicant_6_address2: '',
    applicant_1_city: '',
    applicant_2_city: '',
    applicant_3_city: '',
    applicant_4_city: '',
    applicant_5_city: '',
    applicant_6_city: '',
    applicant_1_county: '',
    applicant_2_county: '',
    applicant_3_county: '',
    applicant_4_county: '',
    applicant_5_county: '',
    applicant_6_county: '',
    applicant_1_state: '',
    applicant_2_state: '',
    applicant_3_state: '',
    applicant_4_state: '',
    applicant_5_state: '',
    applicant_6_state: '',
    applicant_1_zip: '',
    applicant_2_zip: '',
    applicant_3_zip: '',
    applicant_4_zip: '',
    applicant_5_zip: '',
    applicant_6_zip: '',
    applicant_1_citizen_status: 'US Citizen or US National',
    applicant_2_citizen_status: 'US Citizen or US National',
    applicant_3_citizen_status: 'US Citizen or US National',
    applicant_4_citizen_status: 'US Citizen or US National',
    applicant_5_citizen_status: 'US Citizen or US National',
    applicant_6_citizen_status: 'US Citizen or US National',
    applicant_1_citizen_status_proof_id: '',
    applicant_2_citizen_status_proof_id: '',
    applicant_3_citizen_status_proof_id: '',
    applicant_4_citizen_status_proof_id: '',
    applicant_5_citizen_status_proof_id: '',
    applicant_6_citizen_status_proof_id: '',
    applicant_1_citizen_status_proof: '',
    applicant_2_citizen_status_proof: '',
    applicant_3_citizen_status_proof: '',
    applicant_4_citizen_status_proof: '',
    applicant_5_citizen_status_proof: '',
    applicant_6_citizen_status_proof: '',
    applicant_1_currently_enrolled: 'No',
    applicant_2_currently_enrolled: 'No',
    applicant_3_currently_enrolled: 'No', 
    applicant_4_currently_enrolled: 'No',
    applicant_5_currently_enrolled: 'No',
    applicant_6_currently_enrolled: 'No',
    applicant_1_will_expire: 'No',
    applicant_2_will_expire: 'No',
    applicant_3_will_expire: 'No',
    applicant_4_will_expire: 'No',
    applicant_5_will_expire: 'No',
    applicant_6_will_expire: 'No',
    applicant_1_offer_through_job: 'No',
    applicant_2_offer_through_job: 'No',
    applicant_3_offer_through_job: 'No',
    applicant_4_offer_through_job: 'No',
    applicant_5_offer_through_job: 'No',
    applicant_6_offer_through_job: 'No',
    dependent_1_name: '',
    dependent_2_name: '',
    dependent_3_name: '',
    dependent_4_name: '',
    dependent_5_name: '',
    dependent_6_name: '',
    dependent_1_dob: '',
    dependent_2_dob: '',
    dependent_3_dob: '',
    dependent_4_dob: '',
    dependent_5_dob: '',
    dependent_6_dob: '',
    dependent_1_relationship: 'Child',
    dependent_2_relationship: 'Child',
    dependent_3_relationship: 'Child',
    dependent_4_relationship: 'Child',
    dependent_5_relationship: 'Child',
    dependent_6_relationship: 'Child',
    any_pregnant: 'No',
    who_pregnant: '',
    any_tobacco: 'No',
    tobacco_date: '',
    any_currently_incarcerated: 'No',
    incarcerated_pending_disposition: 'Yes',
    any_medicaid_end: '',
    medicaid_end_date: '',
    any_not_medicaid_eligible: '',
    any_native_american: 'No',
    total_income: -1,
    income_types: '',
  });

  const [validationErrors, setValidationErrors] = useState({});
  const applicant_name_divRef = useRef(null);
  const applicant_nameRef = useRef(null);
  const nameRef = useRef(null);
  const email_errorRef = useRef(null);
  const who_will_claimRef = useRef(null);
  
  async function captureContact() {
    var root = document.getElementById('root');
    var height = root.scrollHeight;
    root.style.height = height + 'px';
    var checkboxes = root.querySelectorAll('input[type=checkbox]');
    checkboxes.forEach(i => {
      i.style.display = 'none';
      var span = document.createElement('span');
      span.innerHTML = i.checked ? '&#x2611;' : '&#x2610;';
      span.style.color = 'black';
      i.parentNode.insertBefore(span, i.nextSibling);
    });
    var radios = root.querySelectorAll('input[type=radio]');
    radios.forEach(i => {
      i.style.display = 'none';
      var span = document.createElement('span');
      span.innerHTML = i.checked ? ' &#x25CF; ' : ' &#x25CB; ';
      span.style.color = 'black';
      i.parentNode.insertBefore(span, i.nextSibling);
    });
    
    // capture the image and post it to the server along with the form data
    await htmlToImage.toBlob(root)
    .then(function (blob) {

      let request = new FormData();
      request.append('ghl_note_id', noteId ?? '');
      request.append('current_page', page);
      request.append('form_complete', page === 4)
      Object.keys(formData).forEach(key => request.append(key, formData[key]));
      request.append('image', blob);

      const api_url = process.env.REACT_APP_YIR_API_URL + '/contacts';
      fetch(api_url, { method: 'POST', body: request })
      .catch(function (error) {
        console.error('Error in Fetch', error);
      })
      .then((response) => {
        if (response && response.status === 200) {
          response.json().then(data => {
            setNoteId(data.noteId);
          });
        }
        console.log(response);
      });
    })
    .catch(function (error) {
      console.error('Error in Capture', error);
    });
    document.getElementById('root').style.height = '';
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
  const handleCheck = (event) => {
    const { name } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: event.target.checked ? 'Yes' : 'No' }));
  };
  const handleApplicantName = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    if (formData.self_coverage === 'Yes') {
      setFormData((prevFormData) => ({ ...prevFormData, applicant_name: value }));
    }
  };
  const handleNameDifferent = (event) => {
    if (event.target.checked) {
      setFormData((prevFormData) => ({ ...prevFormData, self_coverage: 'Yes' }));
      setFormData((prevFormData) => ({ ...prevFormData, applicant_name: nameRef.current.value }));
      setFormData((prevFormData) => ({ ...prevFormData, attest_permission: 'No' }));
      applicant_nameRef.current.required = false;
      applicant_name_divRef.current.style.display = 'none';
    } else {
      setFormData((prevFormData) => ({ ...prevFormData, self_coverage: 'No' }));
      setFormData((prevFormData) => ({ ...prevFormData, applicant_name: '' }));
      applicant_name_divRef.current.style.display = 'block';
      applicant_nameRef.current.required = true;
      applicant_nameRef.current.focus();
    }
  };
  const handleEmailChange = (event) => {
    const { name, value } = event.target;
    let email = value;
    setFormData((prevFormData) => ({ ...prevFormData, email: email }));

    // eslint-disable-next-line no-useless-escape
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) {
      email_errorRef.current.style.display = 'none';
      setValidationErrors(errors => {
        const {[name]: _, ...rest} = errors;
        return rest;
      })
    }
    else {
      email_errorRef.current.style.display = 'block';
      setValidationErrors(errors => ({ ...errors, [name]: 'Invalid email' })); // Add email error
    }
  };
  const handleTobacco = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setFormData((prevFormData) => ({ ...prevFormData, tobacco_date: value === 'Yes' ? prevFormData.tobacco_date : '' }));
  };
  const handleIncarcerated = (event) => {
    const { value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, any_currently_incarcerated: value }));
    setFormData((prevFormData) => ({ ...prevFormData, incarcerated_pending_disposition: value === 'Yes' ? 'Yes' : 'No' }));
  };
  const handleHasSSN = (event) => {
    const hasSSN = event.target.checked ? 'Yes' : 'No';
    setFormData((prevFormData) => ({ ...prevFormData, has_ssn: hasSSN }));
    setFormData((prevFormData) => ({ ...prevFormData, no_ssn: hasSSN === 'Yes' ? '' : prevFormData.no_ssn }));
    setFormData((prevFormData) => ({ ...prevFormData, ssn: hasSSN === 'Yes' ? prevFormData.ssn : '' }));
    document.getElementById('no_ssn_section').style.display = hasSSN === 'Yes' ? 'none' : 'block';
    document.getElementById('ssn_section').style.display = hasSSN === 'Yes' ? 'block' : 'none';
    document.getElementById('no_ssn').required = hasSSN === 'Yes' ? false : true;
  };
  const handleNoSSN = (event) => {
    let label = document.getElementById('no_ssn').nextSibling.innerHTML;
    setFormData((prevFormData) => ({ ...prevFormData, no_ssn: event.target.checked ? label : '' }));
  };
  const handleCurrentlyEnrolled = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setFormData((prevFormData) => ({ ...prevFormData, will_expire: value === 'Yes' ? prevFormData.will_expire : 'No' }));
  };
  const handleTaxes = (event) => {
    const { value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, filing_taxes: value }));
    setFormData((prevFormData) => ({ ...prevFormData, is_dependent: value === 'Yes' ? 'No' : prevFormData.is_dependent }));
    setFormData((prevFormData) => ({ ...prevFormData, who_will_claim_name: value === 'Yes' ? '' : prevFormData.who_will_claim_name }));
    setFormData((prevFormData) => ({ ...prevFormData, how_many_dependents: value === 'Yes' ? prevFormData.how_many_dependents : 0 }));
  };
  const handleIsDependent = (event) => {
    const { value } = event.target;
    if (value === 'Yes') {
      setFormData((prevFormData) => ({ ...prevFormData, is_dependent: 'Yes' }));
      setFormData((prevFormData) => ({ ...prevFormData, who_will_claim_name: '' }));
    } else {
      setFormData((prevFormData) => ({ ...prevFormData, is_dependent: 'No' }));
      setFormData((prevFormData) => ({ ...prevFormData, who_will_claim_name: '' }));
    }
  };
  const handleMedicaidEnd = (event) => {
    const { value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, any_medicaid_end: value }));
    setFormData((prevFormData) => ({ ...prevFormData, medicaid_end_date: value === "Yes" ? prevFormData.medicaid_end_date : '' }));
  };
  const handleAnyPregnant = (event) => {
    const { value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, any_pregnant: value }));
    setFormData((prevFormData) => ({ ...prevFormData, who_pregnant: value === "Yes" ? prevFormData.who_pregnant : '' }));
  };
  const handleWhoPregnant = (event) => {
    var checkboxes = document.getElementById('who_pregnant_section').querySelectorAll('input[type=checkbox]');
    var checked = Array.from(checkboxes).filter(i => i.checked).map(i => i.value).join(',');
    setFormData((prevFormData) => ({ ...prevFormData, who_pregnant: checked }));
  };
  const handleDependents = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
  const handleGoBack = () => {
    page === 5 ? setPage(4) : page === 4 ? setPage(3) : page === 3 ? setPage(2) : setPage(1);
  };
  
  async function handlePage1Submit(event) {
    event.preventDefault();
    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    if (page === 1 && event.target.checkValidity()) {
      await captureContact();
      setFormData((prevFormData) => ({ ...prevFormData, first_submit: "false" }));
      setPage(2);
    }
  };
  async function handlePage2Submit(event) {
    event.preventDefault();
    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    if (page === 2 && event.target.checkValidity()) {
      await captureContact();
      setPage(3);
    }
  };
  async function handlePage3Submit(event) {
    event.preventDefault();
    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    if (page === 3 && event.target.checkValidity()) {
      await captureContact();
      setPage(4);
    }
  };
  async function handlePage4Submit(event) {
    event.preventDefault();
    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    if (page === 4 && event.target.checkValidity()) {
      await captureContact();
      setPage(5);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);


  return (
    <div className='ACAForm'>
      <div className='LeftPanel'>
        <div className='FormStep StepActive'>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke='#191919' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="3" fill='#191919'/>
          </svg>
          <div className="StepDetails">
            <div>Your details</div>
            <div className="StepSubtext StepActive">Please provide your contact information</div>
          </div>
        </div>
        <div className={'FormStep' + (page > 1 ? ' StepActive' : '' )}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke={page > 1 ? '#191919' : 'darkgray'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="3" fill={page > 1 ? '#191919' : 'darkgray'}/>
          </svg>
          <div className="StepDetails">
            <div>Applicant details</div>
            <div className={'StepSubtext' + (page > 1 ? ' StepActive' : '' )}>Information about who will be on the policy</div>
          </div>
        </div>
        <div className={'FormStep' + (page > 2 ? ' StepActive' : '' )}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke={page > 2 ? '#191919' : 'darkgray'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="3" fill={page > 2 ? '#191919' : 'darkgray'}/>
          </svg>
          <div className="StepDetails">
            <div>Tax details for {formData.tax_year}</div>
            <div className={'StepSubtext' + (page > 2 ? ' StepActive' : '' )}>Taxes, income, and dependents</div>
          </div>
        </div>
        <div className={'FormStep' + (page > 3 ? ' StepActive' : '' )}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke={page > 3 ? '#191919' : 'darkgray'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="3" fill={page > 3 ? '#191919' : 'darkgray'}/>
          </svg>
          <div className="StepDetails">
            <div>Insurance details</div>
            <div className={'StepSubtext' + (page > 3 ? ' StepActive' : '' )}>Please provide information about key demographic factors</div>
          </div>
        </div>                            
        <div className={'FormStep' + (page > 4 ? ' StepActive' : '' )}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke={page > 3 ? '#191919' : 'darkgray'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="3" fill={page > 4 ? '#191919' : 'darkgray'}/>
          </svg>
          <div className="StepDetails">
            <div>Application submitted</div>
            <div className={'StepSubtext' + (page > 4 ? ' StepActive' : '' )}>Get your insurance coverage</div>
          </div>
        </div>  
      </div>
      <div className='VerticalLine'></div>
      <div className='MainPanel'>
      {page === 1 && (
        <form onSubmit={handlePage1Submit}>
          <div>
            <div className="QuestionBox">
              <label htmlFor="name" className="QuestionLabel">Full name*</label>
              <input className="QuestionInput" type="text" id="name" name="name" placeholder="First and Last name" ref={nameRef} value={formData.name} onChange={handleApplicantName} required/>
            </div>
            <div className="QuestionBox">
              <label htmlFor="email" className="QuestionLabel">Email*</label>
              <input className="QuestionInput" type="email" id="email" name="email" placeholder="i.e. your@email.com" value={formData.email} onChange={handleEmailChange} required/>
              <div className='text_error' ref={email_errorRef}>Please enter a valid email address</div>
            </div>
            <Phone formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            <Address page={page} formData={formData} setFormData={setFormData} />
            <div className="QuestionCheckbox">
              <input type="checkbox" id="self_coverage" name="self_coverage" value={formData.self_coverage} checked={formData.self_coverage === 'Yes'} onChange={handleNameDifferent}/>
              <label htmlFor="self_coverage">I am the primary Applicant</label>
            </div>
            <div style={{display: formData.self_coverage === 'Yes' ? 'none' : 'block'}} ref={applicant_name_divRef}>
              <div className='QuestionBox'>
                <label className="QuestionLabel" htmlFor="name">Name of the primary Applicant:</label>
                <input className="QuestionInput" type="text" id="applicant_name" name="applicant_name" ref={applicant_nameRef} value={formData.applicant_name} onChange={handleChange} />
              </div>
              <div className="QuestionCheckbox">
                <input type="checkbox" id="attest_permission" name="attest_permission" value={formData.attest_permission} checked={formData.attest_permission === 'Yes'} required={formData.self_coverage !== 'Yes'} onChange={handleCheck}/>
                <label htmlFor="attest_permission">I attest that I, {formData.name}, have permission to apply on behalf of the primary Applicant, {formData.applicant_name}</label>
              </div>
            </div>
            <div className='ConsentLanguage'>
              I, <u>{formData.applicant_name}</u>,
              authorize ObamaCare (ACA) certified licensed Agency (NPN#20798208) to assist me, my spouse and/or 
              dependents (if applicable), with Marketplace transactions, and I give them my explicit consent and 
              direction to be my Agent of Record. I am solely responsible for the accuracy/truthfulness of the 
              information I provide. I understand that third party reports may be used to assist in verifying the 
              information I provide. Further, Agent has informed me of their role in the Marketplace. Consent will 
              remain in effect until revoked by me in writing by contacting the Agent directly. I agree to the ACA 
              consent, Acknowledgements, Terms and Conditions, and Privacy Policy. By providing my phone number, I 
              consent to receive marketing and promotional SMS messages from Your Insurance Resource Partners, LLC.
            </div>
            <button className="NextButton" type="submit">
              This acts as my signature 
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 12H17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 7L17 12L12 17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <p className='ConsentLanguage'>
              Click these links to see the <a href={"https://" + formData.source + "/consent"}>ACA Consent</a> 
              , <a href={"https://" + formData.source + "/acknowledgements"}>Acknowledgements</a> 
              , and <a href={"https://" + formData.source + "/terms"}>Terms & Conditions</a>. Message frequency may vary. 
              Reply "STOP" to unsubscribe. Standard message and data rates may apply. Your information will be handled in accordance 
              with our <a href={"https://" + formData.source + "/privacy"}>Privacy Policy</a>
            </p>        
            <div className="ProgressDots">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
               <circle cx="4" cy="4" r="4" fill="#1D304E"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <circle cx="4" cy="4" r="4" fill="#E2E3E9"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <circle cx="4" cy="4" r="4" fill="#E2E3E9"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <circle cx="4" cy="4" r="4" fill="#E2E3E9"/>
              </svg>
            </div>
          </div>
        </form>
      )}
      {page === 2 && (
        <form onSubmit={handlePage2Submit}>
          <div className="BackButton" onClick={handleGoBack}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M17 12L7 12" stroke="#1D304E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 17L7 12L12 7" stroke="#1D304E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            back
          </div>
          <div>
            <h2>{formData.applicant_name}</h2>
            <DateInput label="Date of Birth" fieldName="dob" isRequired={true} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            <div className="QuestionBox">
                <label className="QuestionLabel" htmlFor="gender">Gender</label>
                <select className="QuestionInput" id="gender" name="gender" value={formData.gender} onChange={handleChange} required>
                  <option value="">Select</option>
                  <option value="Female">Female</option>
                  <option value="Male">Male</option>
                  <option value="Non-binary">Non-binary</option>
                </select>
            </div>
            <div className="QuestionCheckbox">
              <input type="checkbox" id="has_ssn" name="has_ssn" value={formData.has_ssn} checked={formData.has_ssn === 'Yes'} onChange={handleHasSSN}/>
              <label htmlFor="has_ssn">{formData.applicant_name.split(' ')[0]} has a Social Security Number</label>
            </div>
            <div className="QuestionCheckbox" id="no_ssn_section" style={{ display: formData.has_ssn === 'Yes' ? 'none' : 'flex' }}>
              <input type="checkbox" id="no_ssn" name="no_ssn" value="Yes" checked={formData.no_ssn.length > 0} onChange={handleNoSSN}/>
              <label htmlFor="no_ssn">I attest that {formData.applicant_name} doesn't have an SSN, because they have never been issued an SSN by the Social Security adminisration</label>
            </div>
            <div id="ssn_section" style={{ display: formData.has_ssn === 'Yes' ? 'block' : 'none' }}>
              <SSN fieldName="ssn" formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            </div>
            <div className="QuestionBox">
              <div>
                <label className="QuestionLabel" htmlFor="offer_through_job">Is {formData.applicant_name.split(' ')[0]} eligible for health coverage from their job or someone else's job (including COBRA)?</label>
              </div>
              <div>
                <input type="radio" id="offer_through_job_yes" name="offer_through_job" value="Yes" checked={formData.offer_through_job === 'Yes'} onChange={handleChange} />
                <label htmlFor="offer_through_job_yes">Yes</label>
                <input type="radio" id="offer_through_job_no" name="offer_through_job" value="No" checked={formData.offer_through_job === 'No'} onChange={handleChange} />
                <label htmlFor="offer_through_job_no">No</label>
              </div>
            </div>
            <div className="QuestionBox">
              <div>
                <label className="QuestionLabel" htmlFor="currently_enrolled">Is {formData.applicant_name.split(' ')[0]} currently enrolled in a health plan?</label>
              </div>
              <div>
                <input type="radio" id="currently_enrolled_yes" name="currently_enrolled" value="Yes" checked={formData.currently_enrolled === 'Yes'} onChange={handleCurrentlyEnrolled} />
                <label htmlFor="currently_enrolled_yes">Yes</label>
                <input type="radio" id="currently_enrolled_no" name="currently_enrolled" value="No" checked={formData.currently_enrolled === 'No'} onChange={handleCurrentlyEnrolled} />
                <label htmlFor="currently_enrolled_no">No</label>
              </div>
            </div>
            <div className="QuestionBox" style={{display:formData.currently_enrolled === 'Yes' ? 'flex' : 'none'}}>
              <div>
                <label className="QuestionLabel" htmlFor="will_expire">Will {formData.applicant_name.split(' ')[0]}'s current health plan expire in the next 60 days?</label>
              </div>
              <div>
                <input type="radio" id="will_expire_yes" name="will_expire" value="Yes" checked={formData.will_expire === 'Yes'} onChange={handleChange} />
                <label htmlFor="will_expire_yes">Yes</label>
                <input type="radio" id="will_expire_no" name="will_expire" value="No" checked={formData.will_expire === 'No'} onChange={handleChange} />
                <label htmlFor="will_expire_no">No</label>
              </div>
            </div>
            <Citizenship i={0} formData={formData} setFormData={setFormData} />
            <hr/>
            <Applicants page={page} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            <div>
              <button className="NextButton" type="submit">
              Next 
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 12H17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 7L17 12L12 17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              </button>
            </div>
          </div>
          <div className="ProgressDots">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#1D304E"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#1D304E"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#E2E3E9"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#E2E3E9"/>
            </svg>
          </div>
        </form>
      )}
      {page === 3 && (
        <form onSubmit={handlePage3Submit}>
          <div className="BackButton" onClick={handleGoBack}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M17 12L7 12" stroke="#1D304E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 17L7 12L12 7" stroke="#1D304E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            back
          </div>
          <div>
            <div className="QuestionBox">
              <div className="QuestionLabel">
                <label htmlFor="filing_taxes">{formData.applicant_name.split(' ')[0]} will be filing taxes for {formData.tax_year}</label>
              </div>              
              <div className="QuestionCheck">
                <input type="radio" id="filing_taxes_yes" name="filing_taxes" value="Yes" checked={formData.filing_taxes === 'Yes'}  onChange={handleTaxes}/>
                <label htmlFor="filing_taxes_yes">Yes</label>
                <input type="radio" id="filing_taxes_no" name="filing_taxes" value="No" checked={formData.filing_taxes === 'No'}  onChange={handleTaxes}/>
                <label htmlFor="filing_taxes_no">No</label>
              </div>
            </div>
            <div className="QuestionBox" style={{display: formData.filing_taxes === 'Yes' && formData.how_many_others > 0 ? 'flex' : 'none'}}>
              <div className="QuestionLabel">
                <label>Describe each applicant's status on {formData.applicant_name.split(' ')[0]}'s {formData.tax_year} taxes:</label>
              </div>
              <div>
                {['applicant_1', 'applicant_2', 'applicant_3', 'applicant_4', 'applicant_5', 'applicant_6'].map((applicant, index) => (
                  formData[`${applicant}_name`] !== '' && (
                    <div key={index}>
                      <div className="ApplicantTaxStatus"><span>{formData[`${applicant}_name`].split(' ')[0]}</span><span>-</span><span>{formData[`${applicant}_dob`].slice(0, 2) + '/' +  formData[`${applicant}_dob`].slice(2, 4) + '/' + formData[`${applicant}_dob`].slice(4)}</span><span>-</span><span>{formData[`${applicant}_relationship`]}</span></div>
                      <span style={{display: formData[`${applicant}_relationship`] === 'Spouse' ? 'inline' : 'none'}}>
                        <input type="radio" id={`${applicant}_tax_status_filing_jointly`} name={`${applicant}_tax_status`} value="Filing jointly" checked={formData[`${applicant}_tax_status`] === 'Filing jointly'} onChange={handleChange} />
                        <label htmlFor={`${applicant}_tax_status_filing_jointly`}>Filing jointly</label>
                        <input type="radio" id={`${applicant}_tax_status_filing_separately`} name={`${applicant}_tax_status`} value="Filing separately" checked={formData[`${applicant}_tax_status`] === 'Filing separately'} onChange={handleChange} />
                        <label htmlFor={`${applicant}_tax_status_filing_separately`}>Filing separately</label>
                      </span>
                      <span>
                        <input type="radio" id={`${applicant}_tax_status_is_dependent`} name={`${applicant}_tax_status`} value="Dependent" checked={formData[`${applicant}_tax_status`] === 'Dependent'} onChange={handleChange} />
                        <label htmlFor={`${applicant}_tax_status_is_dependent`}>Dependent</label>
                      </span>
                      <span style={{display: formData[`${applicant}_relationship`] === 'Spouse' ? 'none' : 'inline'}}>
                        <input type="radio" id={`${applicant}_tax_status_not_claimed`} name={`${applicant}_tax_status`} value="Not claimed" checked={formData[`${applicant}_tax_status`] === 'not claimed'} onChange={handleChange} />
                        <label htmlFor={`${applicant}_tax_status_not_claimed`}>Not claimed</label>                    
                      </span>
                    </div>
                  )
                ))}
              </div>
            </div>
            <div className="QuestionBox" style={{display: formData.filing_taxes === 'Yes' ? 'none' : 'flex'}}>
              <div className="QuestionLabel">
                <label htmlFor="is_dependent">Will anyone else claim {formData.applicant_name.split(' ')[0]} as a dependent on their {formData.tax_year} taxes?</label>
              </div>
              <div className="QuestionCheck">
                <input type="radio" id="is_dependent_yes" name="is_dependent" value="Yes" checked={formData.is_dependent === 'Yes'}  onChange={handleIsDependent}/>
                <label htmlFor="is_dependent_yes">Yes</label>
                <input type="radio" id="is_dependent_no" name="is_dependent" value="No" checked={formData.is_dependent === 'No'}  onChange={handleIsDependent}/>
                <label htmlFor="is_dependent_no">No</label>
              </div>
            </div>
            <div className="QuestionBox" style={{display: formData.is_dependent === 'Yes' ? 'flex' : 'none'}} ref={who_will_claimRef}>
              <label className="QuestionLabel" htmlFor="who_will_claim_name">Who will claim {formData.applicant_name.split(' ')[0]} as a dependent on {formData.tax_year} taxes?</label>
              <input className="QuestionInput" type="text" id="who_will_claim_name" name="who_will_claim_name" placeholder="First and Last Name" value={formData.who_will_claim_name} onChange={handleChange} required={formData.is_dependent === 'Yes'} />
            </div>
            <Income formData={formData} setFormData={setFormData} />
            <div className="QuestionBox" style={{display: formData.filing_taxes === 'Yes' ? 'flex' : 'none'}}>
              <label className="QuestionLabel" htmlFor="how_many_dependents">How many dependents will {formData.applicant_name.split(' ')[0]} claim on {formData.tax_year} taxes{formData.applicant_1_name !== '' ? ' not listed above' : ''}?</label>
              <div className="QuestionSubtext">These people may be on {formData.applicant_name.split(' ')[0]}'s taxes but will not be included on the policy.</div>
              <select className="QuestionInput" id="how_many_dependents" name="how_many_dependents" value={formData.how_many_dependents} onChange={handleDependents}>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
              </select>
            </div>
            <div className="Dependents" style={{display: formData.how_many_dependents > 0 ? 'flex' : 'none'}}>
            { ['dependent_1', 'dependent_2', 'dependent_3', 'dependent_4', 'dependent_5', 'dependent_6'].map((dependent, index) => (
              Number(index) < Number(formData.how_many_dependents) && (
              <div className="Dependent" key={index}>
                <hr/>
                <div className="QuestionBox">
                  <label className="QuestionLabel" htmlFor={`${dependent}_name`}>Name of dependent #{index + 1}</label>
                  <input className="QuestionInput" type="text" placeholder="First and Last name" id={`${dependent}_name`} name={`${dependent}_name`} value={formData[`${dependent}_name`]} onChange={handleChange} required/>
                </div>
                <DateInput label="Date of Birth" fieldName={`${dependent}_dob`} isRequired={true} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
                <div className="QuestionBox">
                  <label className="QuestionLabel" htmlFor={`${dependent}_relationship`}>Relationship to {formData.applicant_name.split(' ')[0]}</label>
                  <select className="QuestionInput" id={`${dependent}_relationship`} name={`${dependent}_relationship`} value={formData[`${dependent}_relationship`]} onChange={handleChange} required>
                    <option value="">Select</option>
                    <option value="Spouse">Spouse</option>
                    <option value="Child">Child</option>
                    <option value="Parent">Parent</option>
                    <option value="Sibling">Sibling</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              )
            ))}
            </div>
            <div>
              <button className="NextButton" type="submit">
              Next 
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 12H17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 7L17 12L12 17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              </button>
            </div>
            <div className="ProgressDots">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <circle cx="4" cy="4" r="4" fill="#1D304E"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <circle cx="4" cy="4" r="4" fill="#1D304E"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <circle cx="4" cy="4" r="4" fill="#1D304E"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <circle cx="4" cy="4" r="4" fill="#E2E3E9"/>
              </svg>
            </div>
          </div>
        </form>
      )}
      {page === 4 && (
        <form onSubmit={handlePage4Submit}>
          <div className="BackButton" onClick={handleGoBack}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M17 12L7 12" stroke="#1D304E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 17L7 12L12 7" stroke="#1D304E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            back
          </div>
          <div className="QuestionBox">
            <div>
              <label className="QuestionLabel" htmlFor="any_pregnant">Is anyone on this application pregnant?</label>
            </div>
            <div>
              <input type="radio" id="any_pregnant_yes" name="any_pregnant" value="Yes" checked={formData.any_pregnant === 'Yes'} onChange={handleAnyPregnant} />
              <label htmlFor="any_pregnant_yes">Yes</label>
              <input type="radio" id="any_pregnant_no" name="any_pregnant" value="No" checked={formData.any_pregnant === 'No'} onChange={handleAnyPregnant} />
              <label htmlFor="any_pregnant_no">No</label>
            </div>
          </div>
          <div className="QuestionBox" style={{ display: formData.any_pregnant === 'Yes' ? 'flex' : 'none' }}>
            <label className="QuestionLabel" htmlFor="who_pregnant">Check all pregnant applicants:</label>
            <div id="who_pregnant_section">
              {[0, 1, 2, 3, 4, 5, 6].map((index) => {
                const applicantName = index === 0 ? formData.applicant_name : formData[`applicant_${index}_name`];
                return applicantName !== '' && (
                  <div key={index}>
                    <input type='checkbox' id={`who_pregnant_${index}`} name={`who_pregnant_${index}`} 
                      value={applicantName} checked={formData.who_pregnant.includes(applicantName)} onChange={handleWhoPregnant}
                    />
                    {applicantName}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="QuestionBox">
            <div>
              <label className="QuestionLabel" htmlFor="any_tobacco">Has anyone on this application used tobacco regularly in the last 6 months?</label>
            </div>
            <div>
              <input type="radio" id="any_tobacco_yes" name="any_tobacco" value="Yes" checked={formData.any_tobacco === 'Yes'} onChange={handleTobacco} />
              <label htmlFor="any_tobacco_yes">Yes</label>
              <input type="radio" id="any_tobacco_no" name="any_tobacco" value="No" checked={formData.any_tobacco === 'No'} onChange={handleTobacco} />
              <label htmlFor="any_tobacco_no">No</label>
            </div>
          </div>
          <div className="QuestionBox" style={{ display: formData.any_tobacco === 'Yes' ? 'flex' : 'none' }}>
            <label className="QuestionLabel" htmlFor="who_tobacco">Check all applicants who used tobacco regularly in the last 6 months:</label>
            <div id="who_tobacco_section">
              {[0, 1, 2, 3, 4, 5, 6].map((index) => {
                const applicantName = index === 0 ? formData.applicant_name : formData[`applicant_${index}_name`];
                return applicantName !== '' && (
                  <div key={index}>
                    <input 
                      type='checkbox' 
                      id={`who_tobacco_${index}`} 
                      name={`who_tobacco_${index}`} 
                      value={applicantName} 
                      // checked={formData.who_tobacco.includes(applicantName)} 
                      // onChange={handleWhoTobacco}
                    />
                    {applicantName}
                  </div>
                );
              })}
            </div>
          </div>
          <div id="tobacco_date_section" style={{ display: formData.any_tobacco === 'Yes' ? 'flex':'none' }}>
            <DateInput label="Approximate date last used:" fieldName='tobacco_date' isRequired={formData.any_tobacco === 'Yes'} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
          </div>
          <div className="QuestionBox">
            <div>
              <label className="QuestionLabel" htmlFor="any_currently_incarcerated">Is anyone on this application currently incarcerated?</label>
            </div>
            <div>
              <input type="radio" id="any_currently_incarcerated_yes" name="any_currently_incarcerated" value="Yes" checked={formData.any_currently_incarcerated === 'Yes'} onChange={handleIncarcerated} />
              <label htmlFor="any_currently_incarcerated_yes">Yes</label>
              <input type="radio" id="any_currently_incarcerated_no" name="any_currently_incarcerated" value="No" checked={formData.any_currently_incarcerated === 'No'} onChange={handleIncarcerated} />
              <label htmlFor="any_currently_incarcerated_no">No</label>
            </div>
          </div>
          <div className="QuestionBox" style={{ display: formData.any_currently_incarcerated === 'Yes' ? 'flex' : 'none '}}>
            <div>
              <label className="QuestionLabel" htmlFor="incarcerated_pending_disposition">Are disposition of charges pending?</label>
            </div>
            <div>
              <input type="radio" id="incarcerated_pending_disposition_yes" name="incarcerated_pending_disposition" value="Yes" checked={formData.incarcerated_pending_disposition === 'Yes'} onChange={handleChange} />
              <label htmlFor="incarcerated_pending_disposition_yes">Yes</label>
              <input type="radio" id="incarcerated_pending_disposition_no" name="incarcerated_pending_disposition" value="No" checked={formData.incarcerated_pending_disposition === 'No'} onChange={handleChange} />
              <label htmlFor="incarcerated_pending_disposition_no">No</label>
            </div>
          </div>
          <div className="QuestionBox">
            <div>
              <label className="QuestionLabel" htmlFor="any_medicaid_end">Does anyone on this application have Medicaid/CHIP coverage that ended or will end between {chip_start} and {chip_end}?</label>
            </div>
            <div>
              <input type="radio" id="any_medicaid_end_yes" name="any_medicaid_end" value="Yes" checked={formData.any_medicaid_end === 'Yes'} onChange={handleMedicaidEnd} required/>
              <label htmlFor="any_medicaid_end_yes">Yes</label>
              <input type="radio" id="any_medicaid_end_no" name="any_medicaid_end" value="No" checked={formData.any_medicaid_end === 'No'} onChange={handleMedicaidEnd} required/>
              <label htmlFor="any_medicaid_end_no">No</label>
            </div>
          </div>
          <div id="medicaid_end_date_section" style={{ display: formData.any_medicaid_end === 'Yes' ? 'flex' : 'none' }}>
            <DateInput 
              label="Date listed on the letter received by the state agency, or your best guess:" 
              fieldName='medicaid_end_date' 
              isRequired={formData.any_medicaid_end === 'Yes'} 
              formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors}
              validStartDate={chip_start_dt} validEndDate={chip_end_dt} />
          </div>
          <div className="QuestionBox">
            <div>
              <label className="QuestionLabel" htmlFor="any_not_medicaid_eligible">Has anyone on this application been denied eligibility for Medicaid/CHIP in the last 90 days?</label>
            </div>
            <div>
              <input type="radio" id="any_not_medicaid_eligible_yes" name="any_not_medicaid_eligible" value="Yes" checked={formData.any_not_medicaid_eligible === 'Yes'} onChange={handleChange} required/>
              <label htmlFor="any_not_medicaid_eligible_yes">Yes</label>
              <input type="radio" id="any_not_medicaid_eligible_no" name="any_not_medicaid_eligible" value="No" checked={formData.any_not_medicaid_eligible === 'No'} onChange={handleChange} required/>
              <label htmlFor="any_not_medicaid_eligible_no">No</label>
            </div>
          </div>
          <div className="QuestionBox">
            <div>
              <label className="QuestionLabel" htmlFor="any_native_american">Is anyone on this application American Indian or Alaskan Native?</label>
            </div>
            <div>
              <input type="radio" id="any_native_american_yes" name="any_native_american" value="Yes" checked={formData.any_native_american === 'Yes'} onChange={handleChange} />
              <label htmlFor="any_native_american_yes">Yes</label>
              <input type="radio" id="any_native_american_no" name="any_native_american" value="No" checked={formData.any_native_american === 'No'} onChange={handleChange} />
              <label htmlFor="any_native_american_no">No</label>
              <input type="radio" id="any_native_american_decline" name="any_native_american" value="Decline" checked={formData.any_native_american === 'Decline'} onChange={handleChange} />
              <label htmlFor="any_native_american_decline">Prefer not to answer</label>
            </div>
          </div>
          <div>
            <button className="NextButton" type="submit">
            Submit Application 
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M7 12H17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 7L17 12L12 17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            </button>
          </div>
          <div className="ProgressDots">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#1D304E"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#1D304E"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#1D304E"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#1D304E"/>
            </svg>
          </div>
        </form>
      )}
      {page === 5 && (
        <div className="ThankYou">
          <div className="BackButton" onClick={handleGoBack}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M17 12L7 12" stroke="#1D304E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 17L7 12L12 7" stroke="#1D304E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            back
          </div>
          <h2>Thank you for taking the time to complete this form.</h2>
          <p>A licensed agent will reach out to you soon to get your health insurance started.</p>
        </div>
      )}
      </div>
    </div>
  );


}
